/**
 * Shared utility to extract trace ID from HTTP response headers.
 * Checks headers in order: 'atl-traceid', 'x-trace-id'
 * Returns undefined for missing or empty trace IDs.
 */
export const getTraceId = (response: Response): string | undefined => {
	const TRACE_ID_HEADERS = ['atl-traceid', 'x-trace-id'];
	const traceIdHeader = TRACE_ID_HEADERS.find((header) => response.headers.has(header));

	if (traceIdHeader === undefined) {
		return undefined;
	}

	const value = response.headers.get(traceIdHeader);
	// Normalize empty strings to undefined
	return value && value.length > 0 ? value : undefined;
};
